import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";




const RecordAddStep1 = () => {
    const navigate = useNavigate();

    useEffect(() => {

        if (!localStorage.getItem('@roampays-user')) {
            navigate("/login")
        }


    }, []);




    const backToRecords = async (e) => {
        navigate("/records")
    };

    return (
        <>


            <div className="title-box">
                <div className="flex-equal justify-content-start " >
                    <button className="btn btn-link fs-12 d-flex fd-row align-items-center" onClick={backToRecords} >

                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.69765 6.99997L8.68205 4.01557L7.65085 2.98438L3.63525 6.99997L7.65085 11.0156L8.68205 9.98438L5.69765 6.99997Z" fill="white" />
                        </svg>
                        <label >Back</label>

                    </button>

                </div>
                <h3 className="flex-equal justify-content-center fs-32 fs-helvetica color-white">Add to Records</h3>
                <div className="flex-equal justify-content-end" >

                </div>

            </div>

            <div className="box" >

                <div className="record-categories form-content align-items-stretch" >

                    <div className="d-flex fd-row g-12 p-8 cursor-pointer"
                     onClick={() => navigate("/records/record-add-step-2/vaccine")} >
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.69343 5.92936C2.43552 6.18729 2.43552 6.60542 2.69343 6.86334C2.95134 7.12121 3.36948 7.12127 3.62739 6.86334L4.09466 6.39601L6.42926 8.73067L4.56136 10.5986C4.30343 10.8566 4.30343 11.2747 4.56136 11.5326C4.81922 11.7905 5.23736 11.7905 5.49528 11.5326L6.42903 10.5988L14.3679 18.5379C15.3253 19.4953 16.7244 19.7419 17.9093 19.2776L18.5706 19.9389C18.9164 20.2847 19.4062 20.3987 19.847 20.2808L21.3726 21.8066C21.6305 22.0645 22.0486 22.0645 22.3066 21.8066C22.5645 21.5486 22.5645 21.1305 22.3066 20.8726L20.7807 19.3466C20.8982 18.906 20.7841 18.4166 20.4385 18.0709L19.7773 17.4097C20.2417 16.2247 19.9951 14.8255 19.0377 13.868L11.0988 5.92891L12.033 4.99476C12.2909 4.73683 12.2909 4.3187 12.033 4.06078C11.7751 3.80286 11.3569 3.80286 11.099 4.06078L9.23108 5.92874L6.89653 3.5941L7.36318 3.12741C7.6211 2.8695 7.6211 2.45135 7.36318 2.19343C7.10532 1.93552 6.68718 1.93552 6.42926 2.19343L2.69343 5.92936ZM8.42392 6.73589L6.08938 4.40129L4.90181 5.58885L7.23642 7.92352L8.42392 6.73589ZM10.2917 6.73612L7.23619 9.79165L9.75092 12.3064L12.8064 9.25086L10.2917 6.73612ZM10.6848 13.2404L12.0858 14.6414L13.1467 13.5805C13.4046 13.3226 13.8227 13.3226 14.0806 13.5805C14.3386 13.8384 14.3386 14.2566 14.0806 14.5145L13.0198 15.5754L13.9535 16.5091L15.0145 15.4481C15.2724 15.1902 15.6905 15.1902 15.9484 15.4481C16.2063 15.7061 16.2063 16.1242 15.9484 16.3821L14.8875 17.4431L15.1751 17.7307C15.8018 18.3574 16.7178 18.5186 17.4933 18.2142L18.7141 16.9935C19.0185 16.2179 18.8573 15.3019 18.2305 14.6751L13.7403 10.1848L10.6848 13.2404ZM19.6472 18.8962C19.6424 18.8899 19.6371 18.8838 19.6314 18.8781L19.161 18.4077C19.1213 18.452 19.0802 18.4953 19.0377 18.5379C18.9951 18.5804 18.9517 18.6216 18.9074 18.6613L19.3777 19.1317C19.3836 19.1375 19.3897 19.1428 19.396 19.1477C19.4248 19.0964 19.4611 19.0482 19.5047 19.0046C19.5482 18.9611 19.5962 18.925 19.6472 18.8962Z" fill="white" />
                        </svg>
                        <span className="color-white fs-16 flex-grow-1" >
                            Vaccine
                        </span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7323 12.0001L9.61621 6.88398L11.384 5.11621L18.2679 12.0001L11.384 18.884L9.61621 17.1162L14.7323 12.0001Z" fill="white" fill-opacity="0.76" />
                        </svg>
                    </div>


                    <div className="d-flex fd-row g-12 p-8 cursor-pointer" onClick={() => navigate("/records/record-add-step-2/certification")} >
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6511 3.4769C13.0155 2.84129 11.9849 2.84129 11.3493 3.4769L9.9303 4.89593C9.76152 5.06471 9.5326 5.15953 9.29391 5.15953H7.28709C6.38822 5.15953 5.65953 5.88822 5.65953 6.7871V8.79391C5.65953 9.0326 5.56471 9.26152 5.39593 9.43031L3.9769 10.8493C3.34129 11.4849 3.34129 12.5155 3.9769 13.1511L5.39593 14.5701C5.56471 14.7389 5.65953 14.9678 5.65953 15.2065V17.2133C5.65953 18.1122 6.38822 18.8409 7.28709 18.8409H9.29391C9.5326 18.8409 9.76152 18.9357 9.9303 19.1045L11.3493 20.5235C11.9849 21.1591 13.0155 21.1591 13.6511 20.5235L15.0701 19.1045C15.2389 18.9357 15.4678 18.8409 15.7065 18.8409H17.7133C18.6122 18.8409 19.3409 18.1122 19.3409 17.2133V15.2065C19.3409 14.9678 19.4357 14.7389 19.6045 14.5701L21.0235 13.1511C21.6591 12.5155 21.6591 11.4849 21.0235 10.8493L19.6045 9.4303C19.4357 9.26152 19.3409 9.0326 19.3409 8.79391V6.7871C19.3409 5.88822 18.6122 5.15953 17.7133 5.15953H15.7065C15.4678 5.15953 15.2389 5.06471 15.0701 4.89593L13.6511 3.4769ZM10.0765 2.20411C11.4151 0.865558 13.5853 0.865559 14.9238 2.20411L16.0793 3.35953H17.7133C19.6063 3.35953 21.1409 4.8941 21.1409 6.7871V8.42112L22.2963 9.57654C23.6348 10.9151 23.6348 13.0853 22.2963 14.4238L21.1409 15.5793V17.2133C21.1409 19.1063 19.6063 20.6409 17.7133 20.6409H16.0793L14.9238 21.7963C13.5853 23.1348 11.4151 23.1348 10.0765 21.7963L8.92112 20.6409H7.28709C5.3941 20.6409 3.85953 19.1063 3.85953 17.2133V15.5793L2.70411 14.4239C1.36556 13.0853 1.36556 10.9151 2.70411 9.57654L3.85953 8.42112V6.7871C3.85953 4.8941 5.3941 3.35953 7.28709 3.35953H8.92111L10.0765 2.20411ZM16.9122 7.36004C17.321 7.64283 17.4231 8.20345 17.1403 8.61222L11.7444 16.4122C11.5796 16.6504 11.3103 16.7948 11.0206 16.8C10.731 16.8053 10.4566 16.6709 10.2832 16.4389L7.87919 13.221C7.5817 12.8228 7.66333 12.2588 8.06153 11.9614C8.45973 11.6639 9.0237 11.7455 9.3212 12.1437L10.9762 14.3589L15.66 7.58817C15.9428 7.17939 16.5034 7.07726 16.9122 7.36004Z" fill="white" />
                        </svg>
                        <span className="color-white fs-16  flex-grow-1" >

                            Certification
                        </span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7323 12.0001L9.61621 6.88398L11.384 5.11621L18.2679 12.0001L11.384 18.884L9.61621 17.1162L14.7323 12.0001Z" fill="white" fill-opacity="0.76" />
                        </svg>
                    </div>




                    <div className="d-flex fd-row g-12 p-8 cursor-pointer" onClick={() => navigate("/records/record-add-step-2/license")} >
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.421 2.94633L12.5 1.84863L10.579 2.94633C9.37025 3.63706 8.00214 4.00038 6.60992 4.00038H4.5V11.1972C4.5 15.1446 6.61515 18.7894 10.0425 20.7478L12.5 22.1521L14.9575 20.7478C18.3849 18.7894 20.5 15.1446 20.5 11.1972V4.00038H18.3901C16.9979 4.00038 15.6297 3.63706 14.421 2.94633ZM11.9141 12.0004L10.4999 10.5862L9.08569 12.0004L11.9141 14.8288L16.1568 10.5862L14.7425 9.17194L11.9141 12.0004Z" fill="white" />
                        </svg>
                        <span className="color-white fs-16  flex-grow-1" >

                            License
                        </span>

                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7323 12.0001L9.61621 6.88398L11.384 5.11621L18.2679 12.0001L11.384 18.884L9.61621 17.1162L14.7323 12.0001Z" fill="white" fill-opacity="0.76" />
                        </svg>
                    </div>


                </div>



            </div>

        </>


    );
};

export default RecordAddStep1;